import React from 'react';
import PropTypes from 'prop-types';
import {
    FormControl, InputLabel, FormHelperText, Select, MenuItem, withStyles,
} from '@material-ui/core';

/**
 *@desc Estilos aplicados al input contenedor
 */
const CssSelectField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '#E3E3E3',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#E3E3E3',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#E3E3E3',
            },
            '&:hover fieldset': {
                borderColor: '#E3E3E3',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#E3E3E3',
            },
        },
    },
})(FormControl);

/**
 * @desc Componente para renderizar de manera generica un selector
 * @param {*} param0
 */
const SelectBase = React.forwardRef(({
        items, label, field: {
        name, onBlur, value, onChange,
    }, form: {
        touched, errors, setFieldValue, setFieldTouched,
    }, ...props
    }, ref) => {
    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);

    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        } else {
            setFieldTouched(name, true);
            setFieldValue(name, event.target.value);
        }
    };

    const hasError = touched[name] && Boolean(errors[name]);

    return (
      <CssSelectField variant="outlined" fullWidth error={hasError}>
        <InputLabel ref={inputLabel}>{label}</InputLabel>
        <Select
          variant="standard"
          id={name}
          inputRef={ref}
          value={value}
          onChange={handleChange}
          labelWidth={labelWidth}
          onBlur={onBlur}
          name={name}
          {...props}
        >
          <MenuItem value="">
            <em>Seleccione un registro</em>
          </MenuItem>
          {items.map((option) => (
            <MenuItem key={option.value} value={option.value} alignItems="flex-start">
              {option.label}
            </MenuItem>
                ))}
        </Select>
        {hasError && <FormHelperText>{errors[name]}</FormHelperText>}
      </CssSelectField>
    );
});

SelectBase.propTypes = {
    form: PropTypes.shape({
        errors: PropTypes.shape(),
        touched: PropTypes.shape(),
        setFieldTouched: PropTypes.func.isRequired,
        setFieldValue: PropTypes.func.isRequired,
    }).isRequired,
    field: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
    }).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    })).isRequired,
    label: PropTypes.string.isRequired,
};

export default SelectBase;
